import React from "react";
import "./navigation.css";
import { Link } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import { Nav, NavItem, Navbar, Image } from 'react-bootstrap';

const scrollTop = () => {
   	window.scrollTo(0, 0);
}

const scrollMid = () => {
   	window.scrollTo(0, 800);
}

const Navigation = () => (
	<Navbar fluid id="navbar" className="navbar-clear">
	    <Navbar.Header>
	        <Navbar.Brand>
	        	<Link to="/" onClick={ () => scrollTop() } ><Image className="logo-image" src="/media/logo-small.png" /></Link>
	        </Navbar.Brand>
	        <Navbar.Toggle />
	    </Navbar.Header>
 		<Nav>
 			<LinkContainer to="about">
		    	<NavItem eventKey={ 1 } href="/about" onClick={ () => scrollMid() } >About</NavItem>
		  	</LinkContainer>
 			<LinkContainer to="clients">
		    	<NavItem eventKey={ 2 } href="/clients" onClick={ () => scrollMid() } >Clients</NavItem>
		  	</LinkContainer>
			<LinkContainer to="contact">
		    	<NavItem eventKey={ 3 } href="/contact" onClick={ () => scrollMid() } >Contact</NavItem>
		  	</LinkContainer>
		</Nav>
	</Navbar>
);

export default Navigation;


// WEBPACK FOOTER //
// ./src/ui/components/Navigation.js